import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_INVOICE_PROVIDER_RESET = 'PUT_INVOICE_PROVIDER_LOADING';
export const PUT_INVOICE_PROVIDER_LOADING = 'PUT_INVOICE_PROVIDER_SUCCESS';
export const PUT_INVOICE_PROVIDER_SUCCESS = 'PUT_INVOICE_PROVIDER_REJECT';
export const PUT_INVOICE_PROVIDER_REJECT = 'PUT_INVOICE_PROVIDER_RESET';

//* ACTIONS ------------------------------------------------
export const putInvoiceProviderReset = () => ({ type: PUT_INVOICE_PROVIDER_RESET });
export const putInvoiceProviderLoading = () => ({ type: PUT_INVOICE_PROVIDER_LOADING });
export const putInvoiceProviderSuccess = (payload) => ({ type: PUT_INVOICE_PROVIDER_SUCCESS, payload });
export const putInvoiceProviderReject = (payload) => ({ type: PUT_INVOICE_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putInvoiceProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/ProvidersBillingTracking/web/UpdateProvidersBillingTracking`, options);
};


